export const languageOrdering = ["English", "Spanish"];

export const languageCodeMapping = {
  English: "en",
  Spanish: "es",
};
